var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.firstBatchOfThumbnailsAvailable)?_c('div',_vm._l((_vm.options.data),function(item){return _c(_vm.fileIconText(item.FileName),{key:item.FileName,tag:"component",attrs:{"template":item,"mediaClassification":_vm.mediaClassification,"options":_vm.options}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }